import {BsDiamondFill} from "react-icons/bs";

export const Status = ({drawingDiff}) => {
  if (drawingDiff < 0) {
            return <td style={{color: "var(--app-danger-fg)"}}><BsDiamondFill /></td>;
        } else if (drawingDiff > 0.5) {
            return <td style={{color: "darkorange"}}><BsDiamondFill /></td>;
        } else {
            return <td style={{color: "var(--app-success-fg)"}}><BsDiamondFill /></td>;
        }

};